export default __webpack_public_path__ + "71b7eeeed42c097c82315c3ab1f13dc6.svg";